var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEverlance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SETTINGS",
    transform: "translate(-115.000000, -21.000000)",
    stroke: "#31B59F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-100",
    transform: "translate(116.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.851775922,31.657188 C0.358541201,31.8992332 0.130793556,31.6868152 0.34413195,31.1802587 L13.184636,0.691414722 C13.3975067,0.185968719 13.7411261,0.184858206 13.9531697,0.691414722 L26.7157432,31.1802587 C26.927322,31.6857047 26.6939513,31.895545 26.200703,31.6520151 L13.5700725,25.4159356 L0.851775922,31.657188 Z",
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-8",
    fill: "#31B59F",
    points: "13.5700725 0.0675841375 13.5700725 25.4159356 26.8704384 31.8676585"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEverlance);
export default __webpack_public_path__ + "static/media/everlance.1b6383e35a98135207dfa4ba6994e525.svg";
export { ForwardRef as ReactComponent };